import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { translate } from '@openclassrooms/translations';
import { scrollToElement } from '@openclassrooms/ui-web/scroll';
import CourseContext from '../contexts/courseContext';
import COURSE_TABS from '../constants/courseTabs';
import tocItemToUrl from '../services/tocItemToUrl';
import CategoryButton from './CategoryButton';

function ContinueCourseButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { course, nextChapter } = useContext(CourseContext);
  const { categoryColor, isSinglePage } = course;

  const handleContinueCourse = async () => {
    if (isSinglePage) {
      return scrollToElement(document.getElementById(COURSE_TABS.TAB_OVERVIEW), {
        offset: 0,
      });
    }

    const nextChapterPath = tocItemToUrl(course, {
      id: nextChapter?.id,
      type: nextChapter?.type,
      title: nextChapter?.title,
    });

    return navigate(nextChapterPath, {
      state: { from: pathname },
    });
  };

  return (
    <CategoryButton categoryColor={categoryColor} onClick={handleContinueCourse}>
      {translate('course.in_progress.continue.button')}
    </CategoryButton>
  );
}

export default ContinueCourseButton;
